import { _ } from "../../../core/polyglot/polyglot.js";

const knownAccountTypes = {};

/**
 * Simple model representing a Account rule type.
 *
 * @param {"Income"|"Cost"} type
 * @param {function():Renderable} getName - Function returning the name of the account type
 */
class AccountType {
	constructor({ type, getName }) {
		this._type = type;
		this._getName = getName;
	}

	getType() {
		return this._type;
	}

	getName() {
		return this._getName();
	}

	equals(accountType) {
		return this._type === accountType.getType();
	}
}

/**
 * Todo: Add JSDoc comment
 */
export function getAccountTypeFromId(id) {
	return knownAccountTypes[id];
}

export const income = new AccountType({
	type: "Income",
	getName: () => _("income"),
});

export const cost = new AccountType({
	type: "Cost",
	getName: () => _("cost"),
});

knownAccountTypes[income.getType()] = income;
knownAccountTypes[cost.getType()] = cost;
